<template>
    <b-standard-card
        :title="translations.title[lang]"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :loading="loading"
        class="mt-5"  
        height="auto"
        :error-message="errorMessage"
        @submit="updateEmailConfiguration({type: 'email_configuration',
         item: email_credentials,})"
    >
        {{ translations.emailConfigurationInfo[lang] }}
        
        <v-row no-gutters class="mt-3 mb-1">
            <v-col cols="12">
                <b-select 
                    :items="emailProviders"
                    item-text="name"
                    item-value="value"
                    label="Email Providers"
                    v-model="selectedProvider"
                ></b-select>
            </v-col>
        </v-row>

        <v-row no-gutters class="mt-8 mb-1" v-if="selectedProvider === 1">
            <v-col cols="7">
                <b-text-field
                    :label="translations.alias[lang]" 
                    v-model="email_credentials.elastic_settings.email_sender_alias_name"
                ></b-text-field>
            </v-col>

            <v-col cols="7">
                <b-text-field
                    label="Email"
                    v-model="email_credentials.elastic_settings.email"
                ></b-text-field>
            </v-col>
            <v-col cols="12" class="mt-3" v-if="elastic_validation">
                <span class="pr-5" v-for="(item) in showingValidation" :key="item[0]">
                    <v-icon v-if="item[1]"
                        class="b-social-icon"
                        color="green"
                        v-text="icons.mdiCheck"
                    ></v-icon>
                    <v-icon v-else
                        class="b-social-icon mr-n1"
                        color="red"
                        v-text="icons.mdiClose"
                    ></v-icon>
                    {{ item[0] }}
                    <v-tooltip
                    v-if="['spf', 'dkim', 'tracking', 'dmarc' ].includes(item[0])" 
                        color="secondary"
                                    top
                                    max-width="300"
                                >
                                <template v-slot:activator="{ on }">

                    <v-icon
                        class="b-social-icon"
                        style="cursor: pointer;"
                        size="18"
                        v-on="on"
                        color="gray"
                        v-text="icons.mdiInformationVariantCircle"
                        @click="openInfoDialog(item[0])"></v-icon>
                    </template>
                        
                        <span
                                        class="font-weight-bold"
                                        v-text="translations.moreInfo[lang]"
                                    ></span>
                                </v-tooltip>
                </span>
            </v-col>
        </v-row>

        <v-row no-gutters class="mt-8 mb-1" v-if="selectedProvider == 2">
            <v-col cols="7">
                <b-text-field
                    label="Alias (Sender name)" 
                    v-model="email_credentials.smtp_settings.email_sender_alias_name"
                ></b-text-field>
            </v-col>

            <v-col cols="7">
                <b-text-field
                    label="Email"
                    type="email"
                    v-model="email_credentials.smtp_settings.email"
                ></b-text-field>
            </v-col>

            <v-col cols="7">
                <b-text-field
                    label="Host" 
                    v-model="email_credentials.smtp_settings.smtp_host"
                ></b-text-field>
            </v-col>
            
            <v-col cols="7">
                <b-text-field
                    label="Port"
                    type="number"
                    v-model="email_credentials.smtp_settings.smtp_port"
                ></b-text-field>
            </v-col>
            
            <v-col cols="7">
                <b-text-field
                    label="Password"
                    type="password"
                    v-model="email_credentials.smtp_settings.password"
                ></b-text-field>
            </v-col>
        </v-row>
        <v-dialog v-model="infoDialog" max-width="650">
            <b-card
                :title="infoDialogType"
                @cancel="infoDialog = false"
                :submitBtn="false"
            >
            <div  v-if="infoDialogType == 'spf'">
                <v-img src="@/assets/SpfRecord.jpg"></v-img>
                <v-sheet
                    color="rgba(234, 237, 241, 0.57)"
                    outlined
                    class="pa-3 mb-3 d-flex flex-column align-center"
                    v-html="translations.spfInfoExists[lang]"
                >
                </v-sheet>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="font-weight-bold">
                            {{ translations.spfInfoNotFound[lang] }}
                        </v-expansion-panel-header>
                        <v-divider></v-divider>
                        <v-expansion-panel-content>
                            <v-row class="mt-4">
                                <v-col cols="12" md="12" >
                                    <span>{{ translations.spfInfoCreateTitle[lang] }}</span>
                                </v-col>
                                <v-col cols="12" md="12" >
                                    <div class="d-flex align-start">                                <v-icon
                                        class="b-social-icon mr-2"
                                        color="green"
                                        v-text="icons.mdiCheck"
                                    ></v-icon> 
                                    <div><span v-html="translations.spfInfoCreateStep1[lang]"></span></div>
                                </div>
                                </v-col>
                                <v-col cols="12" md="12" >
                                    <div class="d-flex align-start">
                                    <v-icon
                                        class="b-social-icon mr-2"
                                        color="green"
                                        v-text="icons.mdiCheck"
                                    ></v-icon> 
                                <div><span v-html="translations.spfInfoCreateStep2[lang]"></span></div>
                                </div>
                                    <v-row class="mt-2 ml-4">
                                        <v-col cols="12" md="12" class="pb-0 pt-1">
                                            <v-icon
                                                class="b-social-icon mr-0"
                                                color="black"
                                                v-text="icons.mdiCircleSmall"
                                            ></v-icon> 
                                            <span v-html="translations.spfInfoCreateStep21[lang]"></span>
                                        </v-col>
                                        <v-col cols="12" md="12"  class="pb-0 pt-1">
                                            <v-icon
                                                class="b-social-icon mr-0"
                                                color="black"
                                                v-text="icons.mdiCircleSmall"
                                            ></v-icon> 
                                            <span v-html="translations.spfInfoCreateStep22[lang]"></span>
                                        </v-col>
                                        <v-col cols="12" md="12" class="pb-0 pt-1" >
                                            <v-icon
                                                class="b-social-icon mr-0"
                                                color="black"
                                                v-text="icons.mdiCircleSmall"
                                            ></v-icon> 
                                            <span v-html="translations.spfInfoCreateStep23[lang]"></span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="12" >
                                    <div class="d-flex align-start">                                <v-icon
                                        class="b-social-icon mr-2"
                                        color="green"
                                        v-text="icons.mdiCheck"
                                    ></v-icon> 
                                    <div><span v-html="translations.spfInfoCreateStep3[lang]"></span></div>
                                </div>
                                </v-col>
                                <v-col cols=12 md="12" class="mt-3" v-if="infoData[infoDialogType]">
                                        <span class="text-subtitle-2">{{ infoData[infoDialogType].name }}</span>
                                            <v-text-field
                                            v-model="infoData[infoDialogType].value"
                                            class="mt-1 no-border"
                                            filled
                                            readonly
                                            hide-details
                                            flat
                                            ></v-text-field>
                                            <span  style="color: #3d6aff; cursor: pointer;" @click="copyContent(infoData[infoDialogType].name)">
                                            <v-icon
                                                class="b-social-icon ma-2 ml-0 mr-0"
                                                color="primary"
                                                size="22"
                                                v-text="icons.mdiContentCopy"
                                            ></v-icon><span>{{ translations.copy[lang] }}</span>
                                        </span>
                                    </v-col>
                            </v-row>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    
                    <v-expansion-panel>
                        <v-expansion-panel-header class="font-weight-bold">
                            {{ translations.spfInfoFound[lang] }}
                        </v-expansion-panel-header>
                        <v-divider></v-divider>
                        <v-expansion-panel-content>
                            <v-row class="mt-4">
                                <v-col cols="12" md="12" >
                                    <span>{{ translations.spfInfoEditTitle[lang] }}</span>
                                </v-col>
                                <v-col cols="12" md="12" >
                                    <div class="d-flex align-start">                                <v-icon
                                        class="b-social-icon mr-2"
                                        color="green"
                                        v-text="icons.mdiCheck"
                                    ></v-icon> 
                                    <div><span v-html="translations.spfInfoEditStep1[lang]"></span></div>
                                </div>
                                </v-col>
                             
                                <v-col cols="12" md="12" >
                                    <div class="d-flex flex-column">                               
                                        <v-col><span>{{ translations.spfInfoEditStep1Ex1[lang] }}</span></v-col>
                                        <v-sheet
                                            color="rgba(234, 237, 241, 0.57)"
                                            outlined
                                            class="pa-3 mb-0 d-flex flex-column align-center"
                                        >
                                        <span>v=spf1 a mx include:_spf.google.com ~all</span>
                                        </v-sheet>
                                </div>
                                </v-col>
                                <v-col cols="12" md="12" >
                                    <div class="d-flex  flex-column">                               
                                        <v-col><span>{{ translations.spfInfoEditStep1Ex2[lang] }}</span></v-col>
                                        <v-sheet
                                            color="rgba(234, 237, 241, 0.57)"
                                            outlined
                                            class="pa-3 mb-0 d-flex flex-column align-center"
                                        >
                                        {{ infoData.spf.variable }}
                                        </v-sheet>
                                        <span  style="color: #3d6aff; cursor: pointer;" @click="copyContent(infoData.spf.variable)">
                                            <v-icon
                                                class="b-social-icon ma-2 ml-0 mr-0 mb-0"
                                                color="primary"
                                                size="22"
                                                v-text="icons.mdiContentCopy"
                                            ></v-icon><span>{{ translations.copy[lang] }}</span>
                                        </span>
                                </div>
                                </v-col>

                                <v-col cols="12" md="12" >
                                    <div class="d-flex flex-column">                               
                                        <v-col><span>{{ translations.spfInfoEditStep1Ex3[lang] }}</span></v-col>
                                        <v-sheet
                                            color="rgba(234, 237, 241, 0.57)"
                                            outlined
                                            class="pa-3 mb-0 d-flex flex-column align-center"
                                        >
                                        <span>v=spf1 a mx <span class="font-weight-bold text-body-2">{{ infoData.spf.variable }}</span> include:_spf.google.com ~all</span>
                                        </v-sheet>
                                </div>
                                </v-col>
                            </v-row>

                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
                <v-row v-else>
                    
                    <v-col v-if="infoDialogType == 'dmarc'" cols="12" md="12" >
                                    <div class="d-flex flex-column">                               
                                        <v-col><span>{{ translations.dmarcGenerator1[lang] }}
                                            <a rel="noopener noreferrer" target="_blank" :href="infoData.dmarc.generatorUrl">DMARC generator</a>
                                           {{ translations.dmarcGenerator2[lang] }} </span></v-col>
                                   
                                </div>
                                </v-col>
                <v-col cols=12 md="12">
                    <v-icon
                        class="b-social-icon mr-2"
                        color="green"
                        v-text="icons.mdiCheck"
                    ></v-icon><span>{{ translations.infoTick1_1[lang] }}<b>{{ infoDialogType === 'tracking' ? 'CNAME':'TXT' }}</b>{{ translations.infoTick1_2[lang] }}</span>
                </v-col>
                <v-col cols=12 md="12">
                    <v-icon
                        class="b-social-icon mr-2"
                        color="green"
                        v-text="icons.mdiCheck"
                    ></v-icon><span>{{ translations.infoTick2_1[lang] }}<b>Name (Host)</b>{{ translations.infoTick2_2[lang] }}</span>
                </v-col>
                <v-col cols=12 md="12">
                    <v-icon
                        class="b-social-icon mr-2"
                        color="green"
                        v-text="icons.mdiCheck"
                    ></v-icon><span>{{ translations.infoTick2_1[lang] }}<b>Value</b>{{ translations.infoTick2_2[lang] }}</span>
                </v-col>
                <v-col cols=12 md="12" v-if="infoData[infoDialogType]">
                    <span class="text-subtitle-2">Name</span>
                    <v-text-field
                    v-model="infoData[infoDialogType].name"
                    class="mt-1 no-border"
                    filled
                    readonly
                    hide-details
                    flat
                    ></v-text-field>
                    <span  style="color: #3d6aff; cursor: pointer;" @click="copyContent(infoData[infoDialogType].name)">
                    <v-icon
                        class="b-social-icon ma-2 ml-0 mr-0"
                        color="primary"
                        size="22"
                        v-text="icons.mdiContentCopy"
                    ></v-icon><span>{{ translations.copy[lang] }}</span>
                </span>
                </v-col>
                    <v-col cols=12 md="12" v-if="infoData[infoDialogType]">
                        <span class="text-subtitle-2">Value</span>
                        <v-textarea v-if="infoDialogType === 'dkim'"
                        v-model="infoData[infoDialogType].value"
                        class="mt-1 no-border"
                        filled
                        readonly
                        hide-details
                        flat
                        ></v-textarea>
                        <v-text-field v-else
                        v-model="infoData[infoDialogType].value"
                        class="mt-1 no-border"
                        filled
                        readonly
                        hide-details
                        flat
                        ></v-text-field>
                        <span  style="color: #3d6aff; cursor: pointer;" @click="copyContent(infoData[infoDialogType].value)">
                            <v-icon
                                class="b-social-icon ma-2 ml-0 mr-0"
                                color="primary"
                                size="22"
                                v-text="icons.mdiContentCopy"
                            ></v-icon><span>{{ translations.copy[lang] }}</span>
                        </span>
                    </v-col>
                </v-row>
            </b-card>
        </v-dialog>
        <v-btn
        v-if="email_credentials.elastic"
            color="primary"
            class="text-capitalize px-5 footer-left-btn"
            depressed
            :loading="loading"
            @click="validateElasticEmail"
            >{{ translations.verify[lang] }}</v-btn
        >
    </b-standard-card>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/businessProfile/emailConfiguration";
import {mapState, mapGetters, mapMutations, mapActions} from "vuex";
import { mdiCheck, mdiClose, mdiInformationVariantCircle, mdiContentCopy, mdiCircleSmall } from "@mdi/js";

export default {
    name: "EmailConfiguration",

    mixins: [translations],
    data() {
        return {
            emailProviders: [
                {
                    name: "Elastic email server",
                    value: 1
                },
                {
                    name: "Custom smtp server",
                    value: 2
                },
                {
                    name: "Default",
                    value: 3
                }
            ],
            selectedProvider: null,
            icons: {
                mdiCheck,
                mdiClose,
                mdiInformationVariantCircle,
                mdiContentCopy,
                mdiCircleSmall
            },
            infoDialog: false,
            infoDialogType: '',
            infoData:{
                dkim: {
                    name: 'api._domainkey',
                    value: "k=rsa;t=s;p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCbmGbQMzYeMvxwtNQoXN0waGYaciuKx8mtMh5czguT4EZlJXuCt6V+l56mmt3t68FEX5JJ0q4ijG71BGoFRkl87uJi7LrQt1ZZmZCvrEII0YO4mp8sDLXC8g1aUAoi8TJgxq2MJqCaMyj5kAm3Fdy2tzftPCV/lbdiJqmBnWKjtwIDAQAB",
                },
                tracking: {
                    name: 'tracking',
                    value: 'api.elasticemail.com',
                },
                spf: {
                    name: 'Value',
                    value: 'v=spf1 a mx include:_spf.elasticemail.com ~all',
                    variable: 'include:_spf.elasticemail.com',
                },
                dmarc: {
                    generatorUrl: 'https://elasticemail.com/dmarc',
                    name: '_dmarc',
                    value: 'v=DMARC1;p=none;',
                },
            },
            copiedTxt: null,
        }
    },

    computed: {
        ...mapState("loyaltyPanel/businessProfile", [
            "elastic_validation",
        ]),
        lang() {
            return this.$route.params.lang;
        },
        loading() {
            return this.$store.state.loyaltyPanel.businessProfile.loading.email_configuration;
        },
        showingValidation(){
            let validation = {...this.elastic_validation}
            delete validation.mx
            return Object.entries(validation)
        },


        errorMessage() {
            return this.$store.state.loyaltyPanel.businessProfile.errorMessage
                .email_configuration;
        },
        resetSuccess() {
            return this.$store.state.loyaltyPanel.businessProfile.resetSuccess
                .email_configuration;
        },
        email_credentials: {
            get(){
                return this.$store.state.loyaltyPanel.businessProfile.emailConfiguration;
            },
            set(val){
                this.setEmailConfiguration(val)
            }
        }


    },
    methods: {
        ...mapActions("loyaltyPanel/businessProfile", [
            "updateEmailConfiguration",
            "validateElasticEmail",
        ]),
        ...mapMutations("loyaltyPanel/businessProfile", [
            "setEmailConfiguration"
        ]),
        ...mapMutations([
            "setNotification"
        ]),
        async saveEmailConfiguration() {
            await this.updateEmailConfiguration();
        },
        openInfoDialog(type){
            this.infoDialog = true
            this.infoDialogType = type
        },
        copyContent(val){
            let copyDone = {
                en: 'Copied to clipboard!',
                el: 'Αντιγράφηκε!',
                it: 'Copiato'
            }
            navigator.clipboard.writeText(val);
            this.setNotification({
                        show: true,
                        type: "info",
                        text: copyDone[this.lang]
                    });
            setTimeout(() =>   this.setNotification({
                        show: false,
                        type: "info",
                        text: ''
                    }), 2100);
        },
    },

    watch:{
        email_credentials(val){
            if(val.elastic){
                this.selectedProvider = 1
            }else if(val.smtp){
                this.selectedProvider = 2
            }else if(val.default){
                this.selectedProvider = 3
            }
        },
        selectedProvider(val){
            if(val == 1){
                this.email_credentials.elastic = true
                this.email_credentials.smtp = false
                this.email_credentials.default = false
            }else if(val == 2){
                this.email_credentials.elastic = false
                this.email_credentials.smtp = true
                this.email_credentials.default = false
            }else if(val == 3){
                this.email_credentials.elastic = false
                this.email_credentials.smtp = false
                this.email_credentials.default = true
            }
        }
    },
    mounted() {
        
    }

};
</script>
<style>
.footer-left-btn {
    position: absolute;
    left: 0;
    bottom: 0;
    margin-bottom: -45px;
    margin-left: 10px;
}
.no-border.v-text-field > .v-input__control > .v-input__slot::after {
    border: none !important;
}
.no-border.v-text-field > .v-input__control > .v-input__slot::before {
    border: none !important;
}
</style>
